import React from 'react';
import { motion } from 'framer-motion';
import { CameraOff, Briefcase, Smile, Clock } from 'lucide-react';
import { useFormModal } from './FormModal';
export function WhoThisIsFor() {
  const profiles = [{
    icon: <CameraOff className="w-8 h-8 text-white/70" data-id="element-205" />,
    title: 'You avoid smiling in photos',
    description: "You've learned how to smile with your lips closed or hide behind others in family pictures."
  }, {
    icon: <Briefcase className="w-8 h-8 text-white/70" data-id="element-206" />,
    title: 'You want to look more professional',
    description: "You're advancing in your career and want a confident smile that matches your ambition."
  }, {
    icon: <Smile className="w-8 h-8 text-white/70" data-id="element-207" />,
    title: 'You want straight teeth, discreetly',
    description: 'You want the results of braces without the metal brackets and wires drawing attention.'
  }, {
    icon: <Clock className="w-8 h-8 text-white/70" data-id="element-208" />,
    title: "You've put this off for years",
    description: "You've prioritized your kids or family for a long time. Now, it's finally your turn."
  }];
  const {
    openFormModal
  } = useFormModal();
  return <section className="py-10 lg:py-20 bg-white" data-id="element-209">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <div className="text-center max-w-3xl mx-auto mb-8 lg:mb-16" data-id="element-211">
          <h2 className="text-3xl md:text-4xl font-light text-brand-dark mb-3 lg:mb-4" data-id="element-212">
            Is This You?
          </h2>
          <p className="text-lg text-brand-dark/60" data-id="element-213">
            Many of our adult patients come to us feeling self-conscious about
            their smiles. You are not alone.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-8 lg:mb-12" data-id="element-214">
          {profiles.map((profile, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-dark p-5 lg:p-8 rounded-2xl flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300" data-id="element-215">
              <div className="bg-white/10 p-4 rounded-full mb-4 lg:mb-6" data-id="element-216">
                {profile.icon}
              </div>
              <h3 className="text-xl font-medium text-white mb-2 lg:mb-3" data-id="element-217">
                {profile.title}
              </h3>
              <p className="text-white/60 leading-relaxed" data-id="element-218">
                {profile.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-219">
          <button onClick={openFormModal} className="inline-flex items-center gap-2 text-brand-dark font-medium text-lg hover:text-brand-dark/70 transition-colors group" data-id="element-220">
            You deserve this. Claim your $3,000 off
            <span className="group-hover:translate-x-1 transition-transform" data-id="element-221">
              →
            </span>
          </button>
        </motion.div>
      </div>
    </section>;
}